import React from "react";

import Tooltip from "components/tooltip";

import { ReactComponent as WarningIcon } from "static/images/warning-alert.svg";
import styles from "../../paymentsModal.module.scss";

type OptionLabelProps = { value: any; isDisabled: boolean };

const OptionLabel = ({ value, isDisabled }: OptionLabelProps) => {
	return (
		<div className="d-flex">
			{value}
			{isDisabled ? (
				<Tooltip title="Already Withheld">
					<WarningIcon className={styles.optionLabelIcon} />
				</Tooltip>
			) : null}
		</div>
	);
};

export default OptionLabel;
